(function() {
  'use strict';

  /* =========================================================
     SHIPPING COUNTDOWN
  ========================================================= */
  function initShipCountdown() {
    var countdownEl  = document.getElementById('pdShipCountdown');
    var tomorrowEl   = document.getElementById('pdShipTomorrow');
    var tomorrowText = document.getElementById('pdShipTomorrowText');
    if (!countdownEl || !tomorrowEl) return;

    var hEl = document.getElementById('pdShipH');
    var mEl = document.getElementById('pdShipM');
    var sEl = document.getElementById('pdShipS');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function update() {
      var now        = new Date();
      var day        = now.getDay();
      var hours      = now.getHours();
      var isSun      = day === 0;
      var isSat      = day === 6;
      var isFri      = day === 5;
      var pastCutoff = hours >= 12;

      if (isSun || (isSat && pastCutoff) || (isFri && pastCutoff)) {
        countdownEl.style.display = 'none';
        tomorrowEl.style.display  = 'flex';
        if (tomorrowText) tomorrowText.textContent = 'Zamów teraz — wyślemy w poniedziałek';
        return;
      }

      if (pastCutoff) {
        countdownEl.style.display = 'none';
        tomorrowEl.style.display  = 'flex';
        if (tomorrowText) tomorrowText.textContent = 'Zamów teraz — wyślemy jutro';
        return;
      }

      var cutoff    = new Date(now);
      cutoff.setHours(12, 0, 0, 0);
      var diff      = Math.max(0, cutoff - now);
      var totalSecs = Math.floor(diff / 1000);
      var h         = Math.floor(totalSecs / 3600);
      var m         = Math.floor((totalSecs % 3600) / 60);
      var s         = totalSecs % 60;

      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);

      countdownEl.style.display = 'flex';
      tomorrowEl.style.display  = 'none';
    }

    update();
    setInterval(update, 1000);
  }

  /* =========================================================
     VOLUME DISCOUNT HIGHLIGHT
  ========================================================= */
  function initVolumeDiscount() {
    var items = document.querySelectorAll('.pd-vol__tier');
    if (!items.length) return;

    var qtyInput = document.querySelector('#quantity, .qty, input[name="quantity"]');
    if (!qtyInput) return;

    function highlight() {
      var qty = parseInt(qtyInput.value, 10) || 1;
      items.forEach(function(item) {
        var threshold = parseInt(item.getAttribute('data-qty'), 10);
        item.classList.toggle('pd-vol__tier--active', qty >= threshold);
      });
    }

    highlight();
    qtyInput.addEventListener('change', highlight);
    qtyInput.addEventListener('input', highlight);
    document.querySelectorAll('.qtyBtn').forEach(function(btn) {
      btn.addEventListener('click', function() { setTimeout(highlight, 50); });
    });

    var multipliers = { '2': { mult: 2, pct: 95 }, '3': { mult: 3, pct: 92 }, '5': { mult: 5, pct: 90 } };

    function updateVolPrices(priceCents) {
      items.forEach(function(tier) {
        var qty = tier.getAttribute('data-qty');
        var m = multipliers[qty];
        if (!m) return;
        var full = priceCents * m.mult;
        var disc = Math.round(full * m.pct / 100);
        var newEl = tier.querySelector('.pd-vol__new');
        var oldEl = tier.querySelector('.pd-vol__old');
        if (newEl) newEl.textContent = formatMoney(disc);
        if (oldEl) oldEl.textContent = formatMoney(full);
      });
    }

    if (window.jQuery) {
      jQuery('[data-section-type="product"]').on('variantChange', function(evt) {
        var variant = evt.variant;
        if (variant && variant.price) updateVolPrices(variant.price);
      });
    }
  }

  /* =========================================================
     FREE DELIVERY BAR
  ========================================================= */
  function initFreeShipBar() {
    var bar = document.querySelector('.pd-ship-bar.cp-ship');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    if (!threshold) return;

    function fmt(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
    }

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var total      = cart.total_price;
        var remaining  = Math.max(0, threshold - total);
        var pct        = Math.min(100, Math.round(total * 100 / threshold));
        var fillEl     = document.getElementById('cp-ship-fill');
        var amountEl   = document.getElementById('cp-ship-amount');
        var currentEl  = document.getElementById('cp-ship-current');
        var pendingEl  = document.getElementById('cp-ship-pending');
        var achievedEl = document.getElementById('cp-ship-achieved');

        if (fillEl)    fillEl.style.width    = pct + '%';
        if (currentEl) currentEl.textContent = fmt(total);

        if (total >= threshold) {
          if (pendingEl)  pendingEl.style.display  = 'none';
          if (achievedEl) achievedEl.style.display = '';
        } else {
          if (amountEl) amountEl.textContent = fmt(remaining);
        }
      })
      .catch(function() {});
  }

  /* =========================================================
     SVG ICONS — 8 categories
  ========================================================= */
  var S = 'stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"';
  var SVG = function(body) { return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' + S + '>' + body + '</svg>'; };
  var ICONS = {
    protection:    SVG('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>'),
    compatibility: SVG('<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>'),
    material:      SVG('<polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>'),
    dimensions:    SVG('<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/>'),
    charging:      SVG('<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>'),
    cable:         SVG('<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"/><line x1="4" y1="3" x2="8" y2="3"/><line x1="16" y1="3" x2="20" y2="3"/>'),
    surface:       SVG('<path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5S5 13 5 15a7 7 0 0 0 7 7z"/>'),
    application:   SVG('<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>'),
    precision:     SVG('<path d="M3 8V5a2 2 0 0 1 2-2h3"/><path d="M16 3h3a2 2 0 0 1 2 2v3"/><path d="M21 16v3a2 2 0 0 1-2 2h-3"/><path d="M8 21H5a2 2 0 0 1-2-2v-3"/>'),
    visibility:    SVG('<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>'),
    data:          SVG('<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>'),
    design:        SVG('<line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="6" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="4" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="8" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="4" x2="15" y2="4"/><line x1="17" y1="16" x2="23" y2="16"/>'),
    wireless:      SVG('<path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/>'),
    audio:         SVG('<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>'),
    camera:        SVG('<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>'),
    color:         SVG('<circle cx="13.5" cy="6.5" r="1.5"/><circle cx="17.5" cy="10.5" r="1.5"/><circle cx="8.5" cy="7.5" r="1.5"/><circle cx="6.5" cy="12.5" r="1.5"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>'),
    set:           SVG('<line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>'),
    bulb:          SVG('<line x1="9" y1="18" x2="15" y2="18"/><line x1="10" y1="22" x2="14" y2="22"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"/>'),
    target:        SVG('<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>'),
    function:      SVG('<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>'),
    check:         SVG('<polyline points="20 6 9 17 4 12"/>')
  };

  var ICON_KEYWORDS = {
    charging:      ['ładowanie','ładowarka','moc','wat','indukcja','magsafe','qi','szybkie ładowanie','charging','prąd','natężenie','amper'],
    cable:         ['kabel','usb','lightning','jack','złącz','typ c','type-c','hdmi','adapter','przejściówka'],
    data:          ['transfer','transmisja','mb/s','synchronizacja','prędkość przesyłu','przepustowość','dane'],
    protection:    ['ochrona','twardość','szkło','hartowane','odporność','antypoślizg','wytrzymałość','zabezpieczenie','antyuderzeniowe'],
    surface:       ['powłoka','oleofob','hydrof','antyrefleks','smug','odcisk','tłust','nano','warstwa'],
    application:   ['aplikacja','montaż','instalacja','naklejanie','ramka montażow','dedykowana ramka','łatw'],
    precision:     ['krawędź','krawędzie','frezowane','2.5d','zaokrągl','wycięci','precyz','dokład'],
    visibility:    ['przejrzyst','transparent','optyczn','widoczn','czystość obrazu','jasność'],
    compatibility: ['kompatybilność','pasuje','kompatybilny','dopasowanie','obsługuje','przeznaczony','zastosowanie','współpracuje','modele','portafilter','ekspres','tamper'],
    material:      ['materiał','tworzywo','silikon','abs','gąbka','wypełnienie','tkanina','skóra','plusz','stal','aluminium','guma','pianka','nylon','poliester','obudowa','korpus'],
    dimensions:    ['wymiary','masa','waga','rozmiar','grubość','długość','szerokość','wysokość','mm ','cm ','g ','kg','kompaktow','slim','smukł','miniaturow'],
    wireless:      ['bezprzewodow','wi-fi','wifi','bluetooth','nfc'],
    audio:         ['dźwięk','audio','głośnik','mikrofon','muzyk','stereo','bass'],
    camera:        ['aparat','kamera','obiektyw','zdjęci','foto'],
    color:         ['kolor','barwa','odcień','wzór'],
    set:           ['zestaw','komplet','elementy','zawartość','dołączon','w zestawie'],
    design:        ['design','wzornictwo','estetyk','styl','wygląd'],
    function:      ['funkcja','typ','zastosowanie','konstrukcja','element']
  };

  function getIconCat(title) {
    var t = title.toLowerCase();
    for (var cat in ICON_KEYWORDS) {
      var kws = ICON_KEYWORDS[cat];
      for (var i = 0; i < kws.length; i++) {
        if (t.indexOf(kws[i]) !== -1) return cat;
      }
    }
    return null;
  }

  function getIcon(title) {
    var cat = getIconCat(title);
    return ICONS[cat] || ICONS['check'];
  }

  function truncStr(str, len) {
    if (!str) return '';
    str = str.trim();
    return str.length > len ? str.substring(0, len).trim() + '…' : str;
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  /* =========================================================
     DESCRIPTION PARSER
  ========================================================= */
  function initDescriptionParser() {
    var source = document.getElementById('pdDescriptionSource');
    if (!source) return;

    var clone = source.cloneNode(true);
    var ymqCopy = clone.querySelector('.ymq-original-tab');
    if (ymqCopy) ymqCopy.remove();

    var children = Array.from(clone.childNodes);
    var shortDescNodes  = [];
    var featureNodes    = [];
    var specsTable      = null;
    var afterTableNodes = [];
    var foundFeatures   = false;
    var foundTable      = false;

    children.forEach(function(node) {
      var text = node.textContent || '';
      var tag  = node.nodeName ? node.nodeName.toUpperCase() : '';

      if (foundTable) { afterTableNodes.push(node); return; }
      if (tag === 'TABLE' || (tag === 'DIV' && node.querySelector && node.querySelector('table'))) {
        specsTable = node; foundTable = true; return;
      }
      if (text.indexOf('▸') !== -1 || text.indexOf('►') !== -1 || tag === 'UL' || tag === 'OL') {
        featureNodes.push(node); foundFeatures = true; return;
      }
      if (!foundFeatures) { shortDescNodes.push(node); } else { featureNodes.push(node); }
    });

    /* --- Build tiles with title + value, max 4 --- */
    var tiles = [];
    featureNodes.forEach(function(node) {
      var lines = (node.textContent || '').split('\n');
      lines.forEach(function(line) {
        line = line.trim();
        if (!line || tiles.length >= 4) return;
        line = line.replace(/^[▸►\-•*]\s*/, '');
        var colonIdx = line.indexOf(':');
        if (colonIdx > 0) {
          tiles.push({
            title: line.substring(0, colonIdx).trim(),
            value: line.substring(colonIdx + 1).trim()
          });
        }
      });
    });

    var isMobile = window.innerWidth < 768;

    function buildTilesHTML(className) {
      /* Pass 1 — resolve specific categories, collect matched ones */
      var FALLBACK_POOL = ['check', 'function', 'bulb', 'target'];
      var cats = tiles.map(function(t) { return getIconCat(t.title); });
      var matched = cats.filter(function(c) { return c !== null; });
      /* Pass 2 — assign fallbacks to unmatched, avoiding repetition */
      var fbIdx = 0;
      var finalCats = cats.map(function(c) {
        if (c !== null) return c;
        var attempts = 0;
        var fb = FALLBACK_POOL[0];
        while (attempts < FALLBACK_POOL.length) {
          fb = FALLBACK_POOL[fbIdx % FALLBACK_POOL.length];
          fbIdx++;
          if (matched.indexOf(fb) === -1) break;
          attempts++;
        }
        return fb;
      });

      var wrap = document.createElement('div');
      wrap.className = className;
      tiles.forEach(function(t, idx) {
        var tile = document.createElement('div');
        tile.className = 'pd-tile';
        var valueText = t.value ? t.value.trim() : '';
        tile.innerHTML =
          '<div class="pd-tile__icon">' + (ICONS[finalCats[idx]] || ICONS['check']) + '</div>' +
          '<div class="pd-tile__title">' + t.title + '</div>' +
          (t.value ? '<div class="pd-tile__value">' + valueText + '</div>' : '');
        tile.style.cursor = 'pointer';
        tile.setAttribute('data-feat-idx', idx);
        tile.addEventListener('click', function() {
          var anchor = document.getElementById('pd-feat-' + this.getAttribute('data-feat-idx'));
          if (!anchor) return;
          anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
          anchor.classList.add('pd-feat--highlight');
          setTimeout(function() { anchor.classList.remove('pd-feat--highlight'); }, 1800);
        });
        wrap.appendChild(tile);
      });
      return wrap;
    }

    /* --- Panel tiles (#pdPanelTiles) --- */
    var panelTilesEl = document.getElementById('pdPanelTiles');
    if (panelTilesEl && tiles.length) {
      panelTilesEl.appendChild(buildTilesHTML('pd-tiles pd-tiles--panel'));
      var tileHint = document.createElement('p');
      tileHint.className = 'pd-tiles-hint';
      tileHint.textContent = 'Kliknij kafelek, aby dowiedzieć się więcej';
      panelTilesEl.appendChild(tileHint);
    }

    /* --- Hide tabs-listing, inject 2-col layout before it --- */
    var tabsListing = document.querySelector('.tabs-listing');
    if (!tabsListing) return;

    tabsListing.style.display = 'none';

    var contentBlock = document.createElement('div');
    contentBlock.className = 'pd-content-block page-width';

    var twoCol = document.createElement('div');
    twoCol.className = 'pd-tab-cols';

    var leftCol = document.createElement('div');
    leftCol.className = 'pd-tab-col pd-tab-col--desc rte';
    shortDescNodes.forEach(function(n) { leftCol.appendChild(n.cloneNode(true)); });
    featureNodes.forEach(function(n)   { leftCol.appendChild(n.cloneNode(true)); });
    afterTableNodes.forEach(function(n) { leftCol.appendChild(n.cloneNode(true)); });

    /* Tagowanie punktatorów ID-ami dla scroll z kafelków */
    var featItems = leftCol.querySelectorAll('li');
    if (featItems.length) {
      featItems.forEach(function(li, i) { if (i < 4) li.id = 'pd-feat-' + i; });
    } else {
      var featPCount = 0;
      leftCol.querySelectorAll('p, div').forEach(function(el) {
        if (featPCount >= 4) return;
        var txt = el.textContent || '';
        if (txt.indexOf('▸') !== -1 || txt.indexOf('►') !== -1 || (txt.indexOf(':') > 0 && txt.length < 200)) {
          el.id = 'pd-feat-' + featPCount++;
        }
      });
    }

    twoCol.appendChild(leftCol);

    if (specsTable) {
      var rightCol = document.createElement('div');
      rightCol.className = 'pd-tab-col pd-tab-col--specs';
      var specsHeading = document.createElement('h2');
      specsHeading.className = 'pd-specs__heading';
      specsHeading.textContent = 'Specyfikacja techniczna';
      rightCol.appendChild(specsHeading);
      rightCol.appendChild(specsTable.cloneNode(true));

      /* --- Mini related products pod tabelą --- */
      var miniEl = document.getElementById('pdRelatedMini');
      if (miniEl && miniEl.children.length > 0) {
        var miniHeading = document.createElement('p');
        miniHeading.className = 'pd-mini-related-heading';
        var colUrl = miniEl.getAttribute('data-collection-url');
        miniHeading.innerHTML = '<span class="pd-mini-related-heading__left"><svg class="pd-mini-related-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>Z tej samej kolekcji</span>' +
          (colUrl ? '<a href="' + colUrl + '" class="pd-mini-related-see-all btn btn--small">Zobacz wszystkie</a>' : '');
        rightCol.appendChild(miniHeading);
        var miniClone = miniEl.cloneNode(true);
        miniClone.removeAttribute('id');
        miniClone.style.display = '';
        rightCol.appendChild(miniClone);
      }

      twoCol.appendChild(rightCol);
    }

    contentBlock.appendChild(twoCol);
    var modulesWrapper = document.querySelector('.pd-modules-wrapper');
    if (modulesWrapper) {
      modulesWrapper.parentNode.insertBefore(contentBlock, modulesWrapper);
    } else {
      tabsListing.parentNode.insertBefore(contentBlock, tabsListing);
    }
  }

  /* =========================================================
     STRZAŁ DNIA TIMER
  ========================================================= */
  function initDealTimer() {
    var hEl = document.getElementById('pd-deal-h');
    var mEl = document.getElementById('pd-deal-m');
    var sEl = document.getElementById('pd-deal-s');
    if (!hEl || !mEl || !sEl) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now      = new Date();
      var midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      var diff = Math.max(0, midnight - now);
      var s    = Math.floor(diff / 1000);
      hEl.textContent = pad(Math.floor(s / 3600));
      mEl.textContent = pad(Math.floor((s % 3600) / 60));
      sEl.textContent = pad(s % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* =========================================================
     STICKY CTA MOBILE
  ========================================================= */
  function initStickyCTA() {
    var addToCartBtn = document.querySelector('.product-form__cart-submit');
    if (!addToCartBtn) return;

    var priceEl = document.querySelector('[id^="ProductPrice-"]');
    var sticky  = document.createElement('div');
    sticky.className = 'pd-sticky-cta';
    sticky.innerHTML =
      '<span class="pd-sticky-cta__price">' + (priceEl ? priceEl.textContent.trim() : '') + '</span>' +
      '<button class="pd-sticky-cta__btn btn">Dodaj do koszyka</button>';
    document.body.appendChild(sticky);

    sticky.querySelector('.pd-sticky-cta__btn').addEventListener('click', function() {
      addToCartBtn.click();
    });

    var observer = new IntersectionObserver(function(entries) {
      sticky.classList.toggle('pd-sticky-cta--visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(addToCartBtn);
  }

  /* =========================================================
     AJAX ADD TO CART — delegated, wszystkie .cp-add-btn
     Używa CartJS gdy dostępny (aktualizuje licznik i pasek w theme)
  ========================================================= */
  function initAddToCart() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest ? e.target.closest('.cp-add-btn') : null;
      if (!btn) return;
      if (btn.disabled) return;
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!variantId) return;

      e.preventDefault();
      e.stopPropagation();

      var origContent = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '…';

      function onSuccess() {
        btn.innerHTML = '✓';
        setTimeout(function() {
          btn.disabled = false;
          btn.innerHTML = origContent;
        }, 2000);
      }

      function onError() {
        btn.disabled = false;
        btn.innerHTML = origContent;
      }

      /* CartJS aktualizuje licznik, drawer i pasek dostawy automatycznie */
      if (window.CartJS) {
        CartJS.addItem(variantId, 1, {}, { success: onSuccess, error: onError });
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(r) { return r.json(); })
        .then(onSuccess)
        .catch(onError);
      }
    });
  }

  /* =========================================================
     UZUPEŁNIJ OCHRONĘ — cross-sell dla etui/szkła na str. produktu
  ========================================================= */
  function initProtectionModule(done) {
    done = done || function() {};
    var el = document.getElementById('cp-protection');
    var listEl = document.getElementById('cp-protection-list');
    if (!el || !listEl) { done(); return; }

    var handle = el.getAttribute('data-handle');

    var CP_PHONES = ['iphone', 'samsung', 'xiaomi', 'huawei', 'motorola', 'oppo', 'sony', 'oneplus', 'realme', 'honor', 'poco', 'google pixel'];
    var CP_ETUI_WORDS = ['etui', 'case', 'pokrowiec', 'obudow'];
    var CP_SZKLO_WORDS = ['szkł', 'szklo', 'hartowane', 'screen protector', 'tempered', 'hydrożel', 'hydrozel', 'folia'];

    function renderProducts(products) {
      var available = products.filter(function(p) { return p.available !== false; });
      if (!available.length) { el.style.display = 'none'; done(); return; }
      var items = available.slice(0, 8);
      listEl.innerHTML = items.map(function(p) {
        var vid = p.variants && p.variants[0] ? p.variants[0].id : '';
        /* suggest API zwraca p.image (string URL), nie featured_image */
        var imgSrc = p.image || '';
        /* suggest API zwraca price jako string w złotych, nie w groszach */
        var priceNum = parseFloat(p.price) || 0;
        var priceStr = priceNum.toFixed(2).replace('.', ',') + ' zł';
        return '<div class="cp-protection-item">' +
          '<div class="cp-protection-item__img-wrap">' +
            '<a href="' + (p.url || '/products/' + p.handle) + '">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="" class="cp-protection-item__img" width="120" height="120" loading="lazy">' : '') +
            '</a>' +
            '<button type="button" class="cp-protection-item__add cp-add-btn" data-variant-id="' + vid + '">+</button>' +
          '</div>' +
          '<a href="' + (p.url || '/products/' + p.handle) + '" class="cp-protection-item__name">' + (p.title || '') + '</a>' +
          '<div class="cp-protection-item__price">' + priceStr + '</div>' +
          '</div>';
      }).join('');
      el.style.display = '';
      initCarousels();
      done();
    }

    if (handle) {
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          /* wykryj typ z tytułu — tak jak cart robi z tytułem pozycji w koszyku */
          var titleLower = (product.title || '').toLowerCase();
          var isEtui = CP_ETUI_WORDS.some(function(w) { return titleLower.indexOf(w) !== -1; });
          var targetTag = isEtui ? 'ochrona ekranu' : 'etui';

          var tags = typeof product.tags === 'string'
            ? product.tags.split(',').map(function(t) { return t.trim(); })
            : (product.tags || []);
          /* identyczna logika jak cpGetModelTag w custom.js — najdłuższy tag z nazwą marki */
          var modelTag = null, modelLen = 0;
          tags.forEach(function(tag) {
            var tl = tag.toLowerCase();
            if (tl === 'etui' || tl === 'ochrona ekranu') return;
            if (CP_PHONES.some(function(ph) { return tl.indexOf(ph) !== -1; }) && tl.length > modelLen) {
              modelTag = tag;
              modelLen = tl.length;
            }
          });

          function fetchByTagScoped(mTag) {
            var q = 'tag:"' + targetTag + '"' + (mTag ? ' tag:"' + mTag + '"' : '');
            fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=12&resources[options][prefix]=last')
              .then(function(r) { return r.json(); })
              .then(function(d) {
                var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
                if (!prods.length && mTag) { fetchByTagScoped(null); } else { renderProducts(prods); }
              })
              .catch(function() { el.style.display = 'none'; done(); });
          }
          fetchByTagScoped(modelTag);
        })
        .catch(function() { el.style.display = 'none'; done(); });
    } else {
      el.style.display = 'none'; done();
    }
  }

  /* =========================================================
     SHARED — deduplication modułów 3 i 4 (identyczna logika jak koszyk)
  ========================================================= */
  var pdShownIds     = {};
  var pdShownHandles = {};
  var PD_ETUI  = ['etui', 'case', 'pokrowiec', 'obudow', 'portfel', 'wallet', 'flip', 'folio'];
  var PD_SZKLO = ['szkł', 'szklo', 'hartowane', 'screen protector', 'tempered', 'folia', 'hydrożel', 'hydrozel'];

  function pdIsProtection(p) {
    if (p.tags) {
      var tl = (Array.isArray(p.tags) ? p.tags : String(p.tags).split(','))
               .map(function(t) { return t.trim().toLowerCase(); });
      if (tl.indexOf('etui') !== -1 || tl.indexOf('ochrona ekranu') !== -1 || tl.indexOf('case') !== -1) return true;
    }
    var title = (p.title || '').toLowerCase();
    for (var i = 0; i < PD_ETUI.length; i++)  { if (title.indexOf(PD_ETUI[i])  !== -1) return true; }
    for (var i = 0; i < PD_SZKLO.length; i++) { if (title.indexOf(PD_SZKLO[i]) !== -1) return true; }
    return false;
  }

  function pdMarkShown(products) {
    (products || []).forEach(function(p) {
      if (p && p.id)     pdShownIds[p.id]        = true;
      if (p && p.handle) pdShownHandles[p.handle] = true;
    });
  }

  function pdFilter(products) {
    return (products || []).filter(function(p) {
      if (!p || !p.id) return false;
      if (pdShownIds[p.id])              return false;
      if (p.handle && pdShownHandles[p.handle]) return false;
      if (p.available === false)         return false;
      if (!p.variants || !p.variants[0]) return false;
      if (pdIsProtection(p))             return false;
      return true;
    });
  }

  function pdNormalize(products) {
    return (products || []).map(function(p) {
      var v0 = p.variants && p.variants[0];
      return {
        id:             p.id,
        handle:         p.handle || '',
        title:          p.title || '',
        url:            p.url || '/products/' + p.handle,
        available:      p.available !== false && (!v0 || v0.available !== false),
        price:          p.price || (v0 ? Math.round(parseFloat(v0.price) * 100) : 0),
        featured_image: p.featured_image || (p.images && p.images[0]) || null,
        variants:       p.variants || [],
        tags:           p.tags || [],
        product_type:   p.product_type || ''
      };
    });
  }

  function pdGetImg(p) {
    var src = '';
    if (p.featured_image) src = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
    else if (p.images && p.images[0]) src = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
    return src ? (src.indexOf('?') !== -1 ? src + '&width=240' : src + '?width=240') : '';
  }

  function pdBuildCard(p) {
    var vid  = p.variants && p.variants[0] ? p.variants[0].id : '';
    var img  = pdGetImg(p);
    var item = document.createElement('div');
    item.className = 'cp-protection-item';
    item.innerHTML =
      '<div class="cp-protection-item__img-wrap">' +
        '<a href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '') + '" width="120" height="120" loading="lazy" class="cp-protection-item__img">' : '') +
        '</a>' +
        '<button type="button" class="cp-protection-item__add cp-add-btn" data-variant-id="' + vid + '"' + (p.available ? '' : ' disabled') + '>+</button>' +
      '</div>' +
      '<a href="' + p.url + '" class="cp-protection-item__name">' + (p.title || '') + '</a>' +
      '<div class="cp-protection-item__price">' + formatMoney(p.price) + '</div>';
    return item;
  }

  function pdMarkModule1() {
    var miniEl = document.getElementById('pdRelatedMini');
    if (!miniEl) return;
    miniEl.querySelectorAll('a').forEach(function(a) {
      var parts = (a.getAttribute('href') || '').split('/products/');
      if (parts[1]) pdShownHandles[parts[1].split('?')[0]] = true;
    });
  }

  function pdFetchBestSelling(cb) {
    fetch('/collections/all/products.json?sort_by=best-selling&limit=200')
      .then(function(r) { return r.json(); })
      .then(function(d) { cb(pdFilter(pdNormalize(d.products || []))); })
      .catch(function() { cb([]); });
  }

  function pdRenderList(list, items) {
    list.innerHTML = '';
    items.forEach(function(p) { list.appendChild(pdBuildCard(p)); });
    pdMarkShown(items);
    initCarousels();
  }

  /* =========================================================
     DOBIERZ DO ZESTAWU — moduł 3
  ========================================================= */
  function initRelatedModule(done) {
    done = done || function() {};
    var module = document.getElementById('pd-related-module');
    var list   = document.getElementById('pd-related-list');
    if (!module || !list) { done(); return; }

    var productId = module.getAttribute('data-product-id');
    if (!productId) { done(); return; }

    pdMarkModule1();

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=10')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var fromRecs = pdFilter(pdNormalize(d.products || []));
        pdFetchBestSelling(function(fromBS) {
          var combined = fromRecs.concat(fromBS).slice(0, 30);
          if (combined.length) pdRenderList(list, combined);
          done();
        });
      })
      .catch(function() {
        pdFetchBestSelling(function(filtered) {
          if (filtered.length) pdRenderList(list, filtered.slice(0, 30));
          done();
        });
      });
  }

  /* =========================================================
     REKOMENDOWANE DLA CIEBIE — moduł 4
  ========================================================= */
  function initRecsModule() {
    var module = document.getElementById('cp-recs');
    if (!module) return;
    var productId = module.getAttribute('data-product-id');
    if (!productId) return;
    var list = document.getElementById('cp-recs-list');
    if (!list) return;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=10')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var fromRecs = pdFilter(pdNormalize(d.products || []));
        pdFetchBestSelling(function(fromBS) {
          var combined = fromRecs.concat(fromBS).slice(0, 30);
          if (!combined.length) { module.style.display = 'none'; return; }
          pdRenderList(list, combined);
        });
      })
      .catch(function() {
        pdFetchBestSelling(function(filtered) {
          if (filtered.length) pdRenderList(list, filtered.slice(0, 30));
          else module.style.display = 'none';
        });
      });
  }

  /* =========================================================
     CAROUSELS — prev/next dla wszystkich .cp-carousel-wrap
  ========================================================= */
  function initCarousels() {
    document.querySelectorAll('.cp-carousel-wrap').forEach(function(wrap) {
      var list = wrap.querySelector('.cp-module__list');
      if (!list) return;

      /* wymuś scroll poziomy */
      list.style.overflowX = 'auto';
      list.style.scrollBehavior = 'smooth';
      list.style.display = 'flex';
      list.style.flexWrap = 'nowrap';
      list.style.gap = '12px';

      var prev = wrap.querySelector('.cp-carousel-prev');
      var next = wrap.querySelector('.cp-carousel-next');

      var scrollAmount = 280;

      if (prev) {
        prev.addEventListener('click', function() {
          list.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          list.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }

      /* pokaż/ukryj strzałki — tylko na scroll, domyślnie widoczne */
      if (prev) prev.style.opacity = '0.3';
      if (next) next.style.opacity = '1';

      function updateArrows() {
        if (prev) prev.style.opacity = list.scrollLeft > 10 ? '1' : '0.3';
        if (next) {
          var canScroll = list.scrollWidth > list.clientWidth + 10;
          var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 10;
          next.style.opacity = (canScroll && !atEnd) ? '1' : '0.3';
        }
      }
      list.addEventListener('scroll', updateArrows);
    });
  }

  /* =========================================================
     INIT
  ========================================================= */
  function initVariantPills() {
    var wrappers = document.querySelectorAll('.selector-wrapper.js');
    if (!wrappers.length) return;

    wrappers.forEach(function(wrapper) {
      var select = wrapper.querySelector('select.single-option-selector');
      if (!select) return;

      var pillWrap = document.createElement('div');
      pillWrap.className = 'pd-variant-pills';

      Array.from(select.options).forEach(function(opt) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'pd-variant-pill' + (opt.selected ? ' pd-variant-pill--active' : '');
        pill.textContent = opt.value;
        pill.setAttribute('data-value', opt.value);
        if (opt.disabled) {
          pill.disabled = true;
          pill.classList.add('pd-variant-pill--sold-out');
        }
        pill.addEventListener('click', function() {
          pillWrap.querySelectorAll('.pd-variant-pill').forEach(function(p) {
            p.classList.remove('pd-variant-pill--active');
          });
          pill.classList.add('pd-variant-pill--active');
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        pillWrap.appendChild(pill);
      });

      select.style.display = 'none';
      wrapper.appendChild(pillWrap);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initShipCountdown();
    initVolumeDiscount();
    initFreeShipBar();
    initDescriptionParser();
    initDealTimer();
    initAddToCart();
    initCarousels();
    initVariantPills();
    initProtectionModule(function() {
      initRelatedModule(function() {
        initRecsModule();
      });
    });
    // if (window.innerWidth < 768) initStickyCTA(); // wyłączone — sticky pasek mobilny
  });

})();
